import React, { useEffect } from "react";

import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';

export const DownloadMenuButton = (props) => {

    useEffect(() => {
    }, []);

    return (
        <a href="/Brands/GBK/Menu.pdf" target="_blank">
            <Button outline size="lg">
                    <FontAwesomeIcon icon={faBars}></FontAwesomeIcon> Download the Menu
            </Button>
        </a>
    );
};
